module.exports = __webpack_public_path__ + "static/media/logo-bds.81dd3379.jpg";